import PageMeta from "components/PageMeta";
import { Account } from "models/Account";
import { Tenant } from "models/Tenant";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert } from "reactstrap";
import * as api from "services/Api";
import AccountFormCard from "./components/AccountFormCard";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

const AccountCreate: React.FC = () => {
    const { t } = useOfficeTranslation();
    const navigate = useNavigate();
    const [account, setAccount] = useState(new Account());
    const [tenants, setTenants] = useState<Tenant[]>([]);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    useEffect(() => { api.getTenants().then(setTenants); }, []);
    const save = () => { setSaving(true); setError(""); api.createAccount(account).then(created => navigate(`/accounts/${created.id}`)).catch(reason => setError(String(reason.response?.data?.error ?? reason))).finally(() => setSaving(false)); };
    return <div className="page-content"><PageMeta title={t("common.newAccount")} /><div className="page-title-box"><Link to="/accounts" className="text-muted"><i className="mdi mdi-arrow-left me-1" />{t("common.accounts")}</Link><h4 className="mt-2">{t("common.newAccount")}</h4></div>{error && <Alert color="danger">{error}</Alert>}<AccountFormCard account={account} tenants={tenants} saving={saving} submitLabel={t("accounts.accountCreate.createAccount")} vatLookup={api.vatCheck} kvkLookup={api.kvkCheck} onChange={setAccount} onSubmit={save} /></div>;
};
export default AccountCreate;
